import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { JBInnerHtmlModule } from '@shared/jb-inner-html';
import { LinkIconModule } from '@shared/link-icon/link-icon.module';
import { LinksModule } from '@shared/ui/links';
import { DealLegalTextFormatterPipe } from '@shared/ui/pipes/dealLegalFormatterPipe/deal-legal-text-formatter.pipe';
import { PipesModule } from '@shared/ui/pipes/pipes.module';
import {
  JbBackgroundImageModule,
  JbButtonModule,
  JbFlagModule,
  JbIconModule,
  JbImageModule,
  JbOfferBlockModule,
  JbOverlayImageModule,
  JbPromoBlockModule,
  JbSrOnlyModule,
} from 'jb-component-library';

import { PromoBlockComponent } from './promo-block.component';
import { promoBlockResolver } from './promo-block.resolver';

const MODULES = [
  CommonModule,
  JbPromoBlockModule,
  JbOfferBlockModule,
  JbFlagModule,
  JbOverlayImageModule,
  JbBackgroundImageModule,
  JbIconModule,
  JbSrOnlyModule,
  JbImageModule,
  JbButtonModule,
  PipesModule,
  LinksModule,
  LinkIconModule,
  JBInnerHtmlModule,
];

const DECLARATIONS = [PromoBlockComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
  providers: [DealLegalTextFormatterPipe],
})
export class PromoBlockModule {
  static entry = PromoBlockComponent;
  static componentDataResolver = promoBlockResolver;
}
